import { Injector } from "@angular/core";
import { BaseNode } from "../../BaseNode";
import { Art57Section } from "../../../Art57Section/Art57Section";
import { SubstanceAliasEntity } from "../../../Data/MedicinalProductData/SubstanceAliasEntity";
import { SourceAutoUploadEntity } from "./SourceAutoUploadEntity";
import { TreeNodeMedicinalProductsAliasTranslation } from "../ListEntity/TreeNodeMedicinalProductsAliasTranlation";
import { environment } from "../../../../../../environments/environment";

export class TreeNodeSubstanceAlias extends BaseNode {

    useHist: boolean = false;
    cloningNode: boolean = false;
    items: any;
    constructor(injector: Injector, cloningNode: boolean, model: any, parent:any) {
        super(injector,
            new SubstanceAliasEntity(injector, model),
            `${model.sourcename}
            - ${model.aliasname}`);

        this.parent=parent;
        this.items = model;
        this.cloningNode = cloningNode;
        if (this.cloningNode) {
            return;
        }
        this.ioc!.get(Art57Section).generateNumColumValue(this);

        if (model.sourcecode){
            this.children?.push(new SourceAutoUploadEntity(this.ioc!, model.sourcecode.value + " - " + model.sourcecode.name, this, model.source,this.useHist,true, false));
        }

        if (model.aliastranslations){
            this.children?.push(new TreeNodeMedicinalProductsAliasTranslation(this.ioc!,this, false, model.aliastranslations.aliastranslation));
        }
    }

    public getListItem(): any[] {
        return [this.data.model.sourcename, this.data.model.aliasname];
    }

    override cloneNode(newParent: BaseNode): BaseNode|undefined {
      let clonedNode: TreeNodeSubstanceAlias = new TreeNodeSubstanceAlias(this.ioc!,true,  this.items, newParent);        
      clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));

      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)
 
      this.children?.forEach((child) => {
        let childToClone = child as BaseNode;
        let clonedChildren = childToClone.cloneNode(clonedNode);
        if (clonedChildren) {
            clonedNode.children?.push(clonedChildren);
            clonedChildren.refreshLabel();
        }
      });
  
      clonedNode.cloningNode = false;
      return clonedNode;
    }    
}